module.exports = __webpack_public_path__ + "static/media/pb_background_vday.b8abd7a7.png";